import { Link } from 'react-router'
import { useAuth } from '@klear/ui/contexts/auth-context'
import { ThemeToggle } from '@klear/ui/components/theme-toggle'

const Header = () => {
  const { user, logout } = useAuth()
  return (
    <header className="bg-background sticky top-0 z-10 border-b border-border">
      <div className="max-w-7xl mx-auto px-4 py-2 flex justify-between items-center">
        <Link to="/">
          <h1 className="text-xl font-semibold text-foreground">Klear Admin</h1>
        </Link>
        <nav className="flex items-center gap-2">
          <ThemeToggle />
          {user && (
            <button className="text-muted-foreground hover:text-foreground" onClick={logout}>
              Hey ({user.email}) Logout
            </button>
          )}
        </nav>
      </div>
    </header>
  )
}

export default Header
